export default {
    None: 0,
    NoneActivity: 1,
    RiskInvoice: 2,
    NoneActivityAndRiskInvoce: 3
}